import React from "react";
import Modal from "react-modal";
import { FaSpinner } from "react-icons/fa";

const BorrowModal = ({
  isModalOpen,
  closeModal,
  borrowDate,
  returnDate,
  setReturnDate,
  handleSaveBorrow,
  loading,
}) => {
  return (
    <Modal
      isOpen={isModalOpen}
      onRequestClose={closeModal}
      contentLabel="Borrow Book Modal"
      style={{
        overlay: { backgroundColor: "rgba(0, 0, 0, 0.6)" },
        content: {
          width: "450px",
          height: "260px",
          margin: "auto",
          padding: "20px",
          textAlign: "right",
          direction: "rtl",
          fontFamily: "Tajwal, sans-serif",
        },
      }}
    >
      <h2 className="text-lg font-bold mb-2">استعارة الكتاب</h2>
      <form>
        <div className="mb-3">
          <label className="block mb-1">تاريخ الاستعارة:</label>
          <input
            type="date"
            value={borrowDate}
            readOnly
            className="border p-1 rounded w-full"
          />
        </div>
        <div className="mb-3">
          <label className="block mb-1">تاريخ الإرجاع:</label>
          <input
            type="date"
            value={returnDate}
            onChange={(e) => setReturnDate(e.target.value)}
            className="border p-1 rounded w-full"
          />
        </div>
        <div className="flex justify-end">
          <button
            type="button"
            onClick={closeModal}
            className="bg-red-500 text-white px-3 py-2 rounded mr-1"
          >
            إلغاء
          </button>
          <button
            type="button"
            onClick={handleSaveBorrow}
            className="bg-green-500 text-white px-3 py-2 mr-2 rounded relative"
            disabled={loading}
          >
            {loading ? (
              <FaSpinner className="w-5 h-5 text-white animate-spin" />
            ) : (
              "حفظ"
            )}
          </button>
        </div>
      </form>
    </Modal>
  );
};

export default BorrowModal;
